<div class="modal-header align-items-start">
  <h5 class="modal-title text-capitalize" id="myModalLabel">
    {{ title ? (title | translate) : ('import.value' | translate) }}
  </h5>
  @if (sampleFileUrl) {
    <button
      type="button"
      id="downloadSampleFile"
      (click)="downloadSampleFile()"
      class="btn btn-soft-pink col-md-3 float-start me-2 ms-3"
    >
      {{ 'downloadSampleFile.value' | translate }}
    </button>
  }
  <button
    type="button"
    class="btn-close"
    data-bs-dismiss="modal"
    aria-label="Close"
    (click)="onClose('cancel')"
  ></button>
</div>
<form [formGroup]="fileForm">
  <div class="row g-3 p-3">
    <div class="col-12">
      <!-- <div class="card mb-0"> -->
      <!-- end card header -->
      <!-- <div class="card-body"> -->
      <label class="form-label">{{ lable ? (lable | translate) : ('import.value' | translate) }}</label>
      <div class="mb-2" *ngIf="!getControl('url')?.value">
        <app-common-loading [count]="1" [appearance]="'line'">
          <app-dropzone
            [name]="'excel'"
            [DrpzoneparamName]="'excel'"
            [message]="'select or drag file'"
            (successEvent)="onFileSelected($event, 'url')"
            (errorEvent)="onError($event)"
            [acceptedFile]="['text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']"
            [maxFiles]="1"
          ></app-dropzone>
        </app-common-loading>
      </div>
      <app-common-loading [count]="1" [appearance]="'line'">
        <div class="w-100 position-relative" *ngIf="getControl('url')?.value">
          <a [href]="getControl('url')?.value" [download]="getControl('url')?.value">
            <img class="preview-img img-fluid" src="https://img.icons8.com/ios/100/ms-excel.png" alt="ms-excel" />
          </a>
          <div class="remove-btn" title="Remove image" (click)="removeFiles()">
            <div class="text-danger mdi mdi-close-circle fs-4"></div>
          </div>
        </div>
      </app-common-loading>

      <!-- <div class="text-center mt-4"> -->
      <!-- <button type="button" (click)="SampleFile()" class="btn btn-primary col-md-3 float-start me-2">
            {{ 'SAMPLEFILE.TEXT' | translate }}
          </button> -->
      <!-- <button type="button" class="btn btn-success float-end col-md-3" (click)="importFile()">
            {{ 'DATATABLE.BUTTONS.IMPORT' | translate }}
          </button> -->
      <!-- <button
            type="button"
            class="btn btn-danger float-end col-md-3 me-2"
            (click)="RemoveFile()"
            *ngIf="removeFile === true"
          >
            {{ 'REMOVEFILE.TEXT' | translate }}
          </button> -->
      <!-- </div> -->
      <!-- </div> -->
      <!-- </div> -->
      <!-- end card -->
      <!-- </div> -->
      <!-- end col -->
    </div>
  </div>
</form>
<!-- end row -->
